<template>
    <dynamicSelectVue
        ref="dynamicSelect"
        title="Método de pago"
        :estados="data"
        show="nombre"
        item-value="id"
        v-model="id"
        outlined
        @create="save"
        @delete="destroy"
        @getEstado="getById"
        @update="save"
        @changeElement="change"
    >
        <v-form ref="form" v-model="validForm">
            <v-row class="mt-3">
                <v-col cols="12">
                    <v-text-field
                        outlined
                        v-model="selectedItem.nombre"
                        label="Nombre"
                        :rules="[rules.required]"
                        dense
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-form>
    </dynamicSelectVue>
</template>
<script>
import dynamicSelectVue from "./dynamicSelect.vue";
import { rules } from "../../rules";
export default {
    name: "MetodosDePagoSelect",
    components: {
        dynamicSelectVue,
    },
    props: {
        value: {
            type: [Number, String],
            required: false,
            default: null,
        },
    },
    data() {
        return {
            validForm: true,
            rules: rules,
            id: null,
            data: [],
            selectedItem: {
                id: null,
                nombre: "",
            },
        };
    },
    created() {
        this.id = this.value;
    },
    mounted() {
        this.index();
    },
    watch: {
        value(val) {
            this.id = val;
        },
        id(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        index() {
            axios.get("api/metodos-de-pago").then((res) => {
                this.data = res.data.metodos;
            });
        },

        // Funciones de dynamicSelect
        save() {
            this.$refs.form.validate();
            if (!this.validForm) return;

            if (this.selectedItem.id != null) {
                axios
                    .put(
                        `api/metodos-de-pago/${this.selectedItem.id}`,
                        this.selectedItem
                    )
                    .then((res) => {
                        this.$refs.dynamicSelect.closeDialog();
                        this.$toast.sucs(
                            res.data.message ||
                                "Método de pago guardado con éxito"
                        );
                        this.clearSelectedItem();
                        this.index();
                    })
                    .catch((error) => {
                        if (error.response.status == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Error procesando la solicitud");
                        }
                    });
            } else {
                axios
                    .post("api/metodos-de-pago", this.selectedItem)
                    .then((res) => {
                        this.$refs.dynamicSelect.closeDialog();
                        this.$toast.sucs(
                            res.data.message ||
                                "Método de pago guardado con éxito"
                        );
                        this.clearSelectedItem();
                        this.index();
                    })
                    .catch((error) => {
                        if (error.response.status == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Error procesando la solicitud");
                        }
                    });
            }
        },
        destroy(id) {
            axios
                .delete(`api/metodos-de-pago/${id}`)
                .then((res) => {
                    this.$toast.sucs(
                        res.data.message || "Método de pago eliminado con éxito"
                    );
                    this.index();
                    this.clearSelectedItem();
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        getById(id) {
            if (id != null) {
                axios
                    .get(`api/metodos-de-pago/${id}`)
                    .then((res) => {
                        this.selectedItem = res.data.data;
                    })
                    .catch((error) => {
                        if (error.response.code == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Error procesando la solicitud");
                        }
                    });
            }
        },
        change(id) {
            this.$refs.dynamicSelect.closeDialog();
        },
        clearSelectedItem() {
            this.selectedItem = {
                id: null,
                nombre: "",
            };
        },
    },
};
</script>
